import Quill from "quill";
import * as QuillJs from "quill";
import * as React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
//import "react-quill/dist/quill.bubble.css";
//import "react-quill/dist/quill.core.css";

import { UnprivilegedEditor } from "components/Quill/QuillEditor";
import QuillContainer from "components/Quill/QuillContainer";
import { QuillTranslateToolbar } from "components/Quill/QuillTranslateToolbar";
import { withTranslation, WithTranslation } from "react-i18next";
import { quillMentionConfig } from "components/Quill/Mention/quillMentionConfig";

import "components/Quill/Mention";
import "components/Quill/MagicUrl";

////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps {
    id?: string;
    content: string;
    onChange: (content: string, delta: QuillJs.Delta, source: QuillJs.Sources, editor: UnprivilegedEditor) => void;
    onFocus?: () => void;

    autoFocus?: boolean;
    readOnly?: boolean;
    className?: string;
    height?: number | string;
    placeholder?: string;
    theme?: "snow" | "bubble";
    toolbar?: boolean;
}

type Props = IProps & WithTranslation;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


class QuillTextBox extends React.PureComponent<Props, IState> {
    private quill: Quill;
    private id: string;

    constructor(props: Props) {
        super(props);
        this.state = { editorHtml: '', theme: 'snow' };
        this.id = props.id || `ed_${new Date().getTime()}`;
    }

    static defaultProps = {
        autoFocus: false,
        readonly: false,
    };

    handleChange = (content: string,
        delta: QuillJs.Delta,
        source: QuillJs.Sources,
        editor: UnprivilegedEditor) => {

        this.props.onChange(content, delta, source, editor);
    };

    componentDidMount() {
        if (this.props.autoFocus && this.quill) setTimeout(() => { this.quill.focus(); }, 300);

        var qtt = new QuillTranslateToolbar(this.id, this.props.t);
        qtt.translate();
    }

    render() {
        const style = { "height": this.props.height || "auto" };

        /* 
         * Quill editor formats
         * See https://quilljs.com/docs/formats/
         */
        const EditorFormats: string[] =
            this.props.toolbar
                ? [
                    'header', 'font', 'size', 'align', 'color', 'background',
                    'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
                    'list', 'bullet', 'indent', 'sub', 'super', 'direction',
                    'link', 'video', 'clean', 'mention'
                ]
                : ['mention'];


        /*
         * Quill modules to attach to editor
         * See https://quilljs.com/docs/modules/ for complete options
         */
        const EditorModules = {
            toolbar: this.props.toolbar || false,

            magicUrl: {
            },

            ...quillMentionConfig
        };

        return (
            <QuillContainer style={style} spellCheck={false}>
                <ReactQuill
                    id={this.id}
                    ref={(ref: any) => this.quill = ref}
                    className={this.props.className}
                    theme={this.props.theme}
                    onChange={this.handleChange}
                    onFocus={this.props.onFocus}
                    readOnly={this.props.readOnly}
                    value={this.props.content}
                    modules={EditorModules}
                    formats={EditorFormats}
                    bounds={".quill-region"}
                    placeholder={this.props.placeholder}
                />
            </QuillContainer>
        );
    }
}

export default withTranslation()(QuillTextBox);
